import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";

export default function Submitted() {
  const nav = useNavigate();

  const handleClose = () => {
    // Try to close the tab first (works when opened programmatically).
    // Fall back to the landing so the respondent always has somewhere to go.
    try {
      window.close();
    } catch (_) { /* ignore */ }
    // Give the browser a moment; if the tab is still open, navigate home.
    setTimeout(() => nav("/"), 120);
  };

  return (
    <div className="cw-assessment cw-flow" data-testid="submitted-page">
      <Header variant="forest" />
      <div className="cw-flow-column" style={{ position: "relative" }}>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close this page"
          className="cw-close-btn"
          data-testid="submitted-close-btn"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="cw-fade-in">
          <div
            style={{
              width: 96, height: 96, borderRadius: 999,
              background: "rgba(23,145,104,0.10)",
              border: "1px solid rgba(23,145,104,0.30)",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              color: "var(--cw-emerald)",
            }}
            data-testid="submitted-check"
          >
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path
                d="M4 12l6 6 10-12"
                stroke="currentColor"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="cw-eyebrow" style={{ marginTop: 40 }}>Submitted &middot; Report queued</div>
          <hr className="cw-rule" style={{ marginTop: 20 }} />
          <h1 className="cw-display-l" data-testid="submitted-heading">
            Your report is being prepared.
          </h1>
          <p className="cw-body" style={{ marginTop: 24, maxWidth: 560, color: "rgba(22,30,27,0.82)" }}>
            It will arrive at your inbox within the hour, titled Crowther AI Strategy Audit. If it
            does not, check your spam folder or write to us from the footer of crowtherlabs.com.
          </p>
          <div style={{ marginTop: 40, display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
            <button
              className="cw-btn cw-btn-primary"
              onClick={handleClose}
              data-testid="submitted-close-primary"
            >
              Close
            </button>
            <a
              className="cw-btn-text"
              href="https://crowtherlabs.com"
              data-testid="submitted-visit-site"
            >
              Return to crowtherlabs.com
            </a>
          </div>
          <p className="cw-small" style={{ marginTop: 24 }}>You can close this page.</p>
        </div>
      </div>
    </div>
  );
}
